<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：订单详情
  -->
  <div class="pb50" v-loading="loading" v-if="!loading">
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">基本信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单号：</span>
              {{ detail.order_no }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">买家：</span>
              {{ detail.user.nickName }}
              <span>用户ID：({{ detail.user.user_id }})</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单金额 (元)：</span>
              {{ detail.order.order_price }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">运费金额 (元)：</span>
              {{ detail.order.express_price }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">实付款金额 (元)：</span>
              {{ detail.order.pay_price }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">支付方式：</span>
              {{ detail.order.pay_type.text }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">配送方式：</span>
              {{ detail.order.delivery_type.text }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单交易状态：</span>
              {{ detail.order.order_status.text }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">预约状态：</span>
              {{ detail.status_text }}
            </div>
          </el-col>
        </el-row>
      </div>

      <!--商品信息-->
      <div class="common-form mt16">商品信息</div>
      <div class="table-wrap">
        <el-table size="small" :data="detail.order.product" border style="width: 100%">
          <el-table-column prop="product_name" label="商品" width="400">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image.file_path" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="gray9" v-if="scope.row.product_attr!=''">{{scope.row.product_attr}}</div>
                  <div class="price">
                    <span :class="{'text-d-line':scope.row.is_user_grade==1,'gray6':scope.row.is_user_grade!=1}">￥ {{ scope.row.product_price }}</span>
                    <span class="ml10" v-if="scope.row.is_user_grade==1">
                      会员折扣价：￥ {{ scope.row.grade_product_price }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="product_no" label="商品编码"></el-table-column>
          <el-table-column prop="product_weight" label="重量 (Kg)"></el-table-column>
          <el-table-column prop="total_num" label="购买数量">
            <template slot-scope="scope">
              <p>x {{ scope.row.total_num }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="total_price" label="商品总价(元)">
            <template slot-scope="scope">
              <p>￥ {{ scope.row.total_price }}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--自提门店信息-->
      <template>
        <div class="common-form mt16">用户预约信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系人：</span>
                {{ detail.subscribe_name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系电话：</span>
                {{ detail.subscribe_mobile }}
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.subscribe_time_id>0">
              <div class="pb16">
                <span class="gray9">预约时间：</span>
                {{ detail.subscribe_date?detail.subscribe_date:'' }} {{detail.subscribe_start_time?detail.subscribe_start_time:''}} ~ {{detail.subscribe_end_time?detail.subscribe_end_time:''}}
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="common-form mt16">预约信息</div>
        <div class="table-wrap" v-if="detail.store">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">门店ID：</span>
                {{ detail.store.store_id }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">门店名称：</span>
                {{ detail.store.store_name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系人：</span>
                {{ detail.store.linkman }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系电话：</span>
                {{ detail.store.phone }}
              </div>
            </el-col>
            <el-col :span="15">
              <div class="pb16">
                <span class="gray9">门店地址：</span>
                {{ detail.store.region.province }}- {{ detail.store.region.city }}- {{ detail.store.region.region }}-
                {{ detail.store.address }}
              </div>
            </el-col>
          </el-row>
        </div>
      </template>

      <!--付款信息-->
      <div class="table-wrap" v-if="detail.order.pay_status.value == 20">
        <div class="common-form mt16">付款信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">应付款金额：</span>
                {{ detail.order.pay_price }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">支付方式：</span>
                {{ detail.order.pay_type.text }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">支付流水号：</span>
                {{ detail.order.transaction_id }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">付款状态：</span>
                {{ detail.order.pay_status.text }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">付款时间：</span>
                {{ detail.order.pay_time }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="table-wrap" v-if="detail.status == 2">
        <div class="common-form mt16">核销信息</div>
        <div class="table-wrap">
          <el-row>
            <!-- <el-col :span="5">
              <div class="pb16">
                <span class="gray9">核销人：</span>
                {{ detail.verify.real_name }}( 店员ID：{{ detail.verify.clerk_id }} )
              </div>
            </el-col> -->
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">核销时间：</span>
                {{ detail.verify_time }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">店员：</span>
                {{ detail.clerk.real_name }}( 店员ID：{{ detail.clerk.clerk_id }} )
              </div>
            </el-col>
          </el-row>
        </div>
        <div>
          <!-- <el-form size="small" ref="edit_form" :model="edit_form" label-width="100px">
            <el-form-item label="所属店员">
              <el-select v-model="edit_form.clerk_id" placeholder="点击选择">
                <el-option :label="item.real_name" v-for="(item, index) in shopClerkList" :key="item.clerk_id" :value="item.clerk_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onEdit(detail.reserve_record_id)">确认</el-button>
            </el-form-item>
          </el-form> -->
        </div>
      </div>

      <!--  用户取消订单 -->
     <div v-if="detail.cancel_status == 1" v-auth="'/plus/reserve/reserve/check'">
        <div class="common-form mt16">用户取消预约</div>

        <p class="red pb16"></p>
        <el-form size="small" ref="forms" :model="forms">
          <el-form-item label="审核状态">
            <div>
              <el-radio v-model="forms.cancel_status" :label="1">同意</el-radio>
              <el-radio v-model="forms.cancel_status" :label="0">拒绝</el-radio>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onCheck(detail.reserve_record_id)">确认</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!--门店自提核销-->
      <div>
        <div class="common-form mt16" v-if="detail.status==1">门店核销</div>
        <div v-if="detail.status == 1 && detail.cancel_status!=1">
          <el-form size="small" ref="extract_form" :model="extract_form" label-width="100px">
            <el-form-item label="所属店员">
              <el-select v-model="extract_form.clerk_id" placeholder="点击选择">
                <el-option :label="item.real_name" v-for="(item, index) in shopClerkList" :key="item.clerk_id" :value="item.clerk_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="核销人" v-if="detail.status == 1">
              <el-select v-model="extract_form.verify_id" placeholder="点击选择">
                <el-option :label="item.real_name" v-for="(item, index) in shopClerkList" :key="item.clerk_id" :value="item.clerk_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onExtract(detail.reserve_record_id)">确认核销</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
    </div>
  </div>
</template>

<script>
  import ReserveApi from '@/api/reserve.js';
  import deliveryUser from '@/components/user/deliveryUser';
  import {deepClone} from '@/utils/base.js';
  export default {
    components: {
      deliveryUser,
    },
    data() {
      return {
        active: 0,
        /*是否加载完成*/
        loading: true,
        /*订单数据*/
        detail: {
          order: {
            pay_status: [],
            pay_type: [],
            delivery_type: [],
            user: {},
            address: [],
            product: [],
            order_status: [],
            extract: [],
            extract_store: [],
            express: [],
            delivery_status: [],
            extractClerk: [],
            delivery_warehouse: ''
          },
          store: {},
          user: {},
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*发货*/
        form: {
          /*订单ID*/
          express_id: null,
          /*订单号*/
          express_no: ''
        },
        forms: {
          cancel_status: 1
        },
        extract_form: {
            clerk_id: '',
            verify_id: '',
        },
        order: {},
        delivery_type: 0,
        /*配送方式*/
        exStyle: [],
        /*门店列表*/
        shopList: [],
        /*当前编辑的对象*/
        userModel: {},
        /*时间*/
        create_time: '',
        shopClerkList: [],
        /*是否打开编辑弹窗*/
        open_edit: false,
        supply_id:0,
        // 选择的配送员列表,只有一个
        select_list: [],
        deliveryForm: {

        },
        edit_form: {
          clerk_id: '',
        }
      };
    },
    created() {
      /*获取列表*/
      this.getParams();
    },
    methods: {
      next() {
        if (this.active++ > 4) this.active = 0;
      },
      /*获取参数*/
      getParams() {
        let self = this;
        // 取到路由带过来的参数
        const params = this.$route.query.reserve_record_id;
        ReserveApi.reserveDetail({
            reserve_record_id: params,
            XDEBUG_SESSION_START: 'PHPSTORM',
          }
        ).then(data => {

          self.detail = data.data.detail;
          self.shopClerkList = data.data.shopClerkList;
          self.edit_form.clerk_id = data.data.detail.clerk_id;
          self.loading = false;
        })
          .catch(error => {
            self.loading = false;
          });
      },

      /*确认取消*/
      confirmCancel() {
        let self = this;
        let order_id = this.$route.query.order_id;
        let is_cancel = self.forms.is_cancel;
        OrderApi.confirm({
              order_id: order_id,
              is_cancel: is_cancel
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，审核成功',
              type: 'success'
            });
            self.getParams();
          })
          .catch(error => {
            self.loading = false;
          });
      },

      onCheck(e){
        let self = this;
        let params = self.forms;
        params.reserve_record_id = e;
        ReserveApi.check(params,true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getParams();
          })
          .catch(error => {
            self.loading = false;
          });
      },

      onEdit(e){
        let self = this;
        let params = self.edit_form;
        if(params.clerk_id=='' || params.clerk_id==0){
          self.$message({
            message: '请选择店员',
            type: 'error'
          });
          return;
        }
        params.reserve_record_id = e;
        ReserveApi.extract(params,true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getParams();
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*核销*/
      onExtract(e) {
        let self = this;
        let params = self.extract_form;

        if(params.clerk_id=='' || params.clerk_id==0){
          self.$message({
            message: '请选择店员',
            type: 'error'
          });
          return;
        }
        if(params.verify_id=='' || params.verify_id==0){
          self.$message({
            message: '请选择核销人',
            type: 'error'
          });
          return;
        }
        params.reserve_record_id = e;
        ReserveApi.extract(params,true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getParams();
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/reserve/reserve/detail.vue